import DelayRangeFilter from 'components/Billing/DelayRangeFilter';
import { buildAlertIdOverride } from 'components/Billing/alertAction';
import SummaryCards from 'components/Billing/SummaryCards';
import { buildBillingColumns } from 'components/Billing/columns';
import { buildHistoryOverride } from 'components/Billing/historyAction';
import { buildRenegotiationOverride } from 'components/Billing/renegotiationTag';
import { RenegotiateButton } from 'components/Billing/renegotiateAction';
import BasicTable from 'components/Form/Table';
import TableWrapper from 'components/TableWrapper';
import ContainerAuthenticated from 'containers/Authenticated';
import { CoreContext } from 'context/CoreContext';
import useBillingList from 'hooks/useBillingList';
import { useContext, useMemo } from 'react';
import { StatusContent } from 'ui/styled';
import { BILLING_QUERIES, buildCards } from 'utils/billing';

// Degrau extrajudicial: so contratos com `status = notificacao`, ou seja, os
// que o operador encaminhou da Renegociacao. O atraso nao traz ninguem para ca
// sozinho. O recorte vem da query (BILLING_QUERIES.notificacao).
//
// A acao daqui tem duas saidas: renegociar (o mesmo botao da Renegociacao,
// em components/Billing/renegotiateAction) ou encaminhar para a Execucao.
export default function BillingNotificacao() {
  const { user, setModal } = useContext(CoreContext);
  const {
    loading,
    visibleRows,
    indicators,
    delayFrom,
    setDelayFrom,
    delayTo,
    setDelayTo,
    clearDelay,
    criticalOnly,
    toggleCritical,
    reload,
  } = useBillingList({ query: BILLING_QUERIES.notificacao });

  const columns = useMemo(
    () =>
      buildBillingColumns(
        [
          'id',
          'contrato',
          'data_emissao',
          'banco',
          'distributor',
          'integrator',
          'customer',
          'telefone',
          'parcela',
          'valor_parcelas',
          'data_vencimento',
          'dias_atraso',
          'ultima_tentativa',
          'acao',
          'historico',
        ],
        {
          user,
          overrides: {
            ...buildAlertIdOverride({ setModal, reload }),
            ...buildRenegotiationOverride(),
            ...buildHistoryOverride({ setModal, reload }),
            // As duas saídas da Notificação: renegociar ou encaminhar para a
            // Execução. São operações do CONTRATO, não da parcela: a coluna é
            // `groupLevel`, então a célula só aparece na linha do contrato e
            // fica em branco nas parcelas expandidas.
            acao: {
              renderCell: ({ row }) => (
                <span style={{ display: 'inline-flex', gap: '6px' }}>
                  <RenegotiateButton
                    row={row}
                    setModal={setModal}
                    reload={reload}
                  />
                  <StatusContent
                    color="red"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setModal({
                        type: 'billing_forward',
                        destination: 'execucao',
                        dados: row,
                        reload,
                      });
                    }}
                    title="Encaminhar para Execução — cancela os avisos programados"
                  >
                    Executar
                  </StatusContent>
                </span>
              ),
            },
          },
        }
      ),
    [user, setModal, reload]
  );

  const cards = buildCards(indicators, {
    onToggleCritical: toggleCritical,
    criticalActive: criticalOnly,
  });

  return (
    <ContainerAuthenticated>
      <TableWrapper
        title="Notificação"
        search
        filters={
          <DelayRangeFilter
            from={delayFrom}
            to={delayTo}
            onChangeFrom={setDelayFrom}
            onChangeTo={setDelayTo}
            onClear={clearDelay}
          />
        }
      >
        <SummaryCards cards={cards} />
        <BasicTable
          loading={loading}
          columns={columns}
          rows={visibleRows}
          groupBy="id"
          pagination
        />
      </TableWrapper>
    </ContainerAuthenticated>
  );
}
